import { useEffect, useState, useCallback } from "react";
import { createPortal } from "react-dom";

export type ToastTone = "success" | "warn" | "crit" | "info";

interface ToastState {
  id: number;
  message: string;
  tone: ToastTone;
}

let externalShow: ((message: string, tone?: ToastTone) => void) | null = null;

export function showToast(message: string, tone: ToastTone = "success") {
  externalShow?.(message, tone);
}

export default function ToastHost() {
  const [toast, setToast] = useState<ToastState | null>(null);

  const show = useCallback((message: string, tone: ToastTone = "success") => {
    setToast({ id: Date.now(), message, tone });
  }, []);

  useEffect(() => {
    externalShow = show;
    return () => {
      externalShow = null;
    };
  }, [show]);

  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(() => setToast(null), 2800);
    return () => clearTimeout(t);
  }, [toast]);

  if (!toast) return null;
  return createPortal(
    <div className={`toast ${toast.tone}`} role="status" aria-live="polite">
      {toast.message}
    </div>,
    document.body
  );
}
